export default __webpack_public_path__ + "static/media/downcast.c1266a88.png";